import { useCallback, useMemo } from "react";
import mapboxgl from "mapbox-gl";
import { isValidCoordinate } from "../utils/mapHelpers";

export const useMapControls = (devices, organisation, mapRef, pitch = 0) => {
  const filteredDevices = useMemo(
    () =>
      Array.isArray(devices)
        ? devices.filter((device) =>
            isValidCoordinate(device?.lng, device?.lat)
          )
        : [],
    [devices]
  );

  const center = useMemo(() => {
    if (!organisation.center) return [0, 0];
    return typeof organisation.center === "string"
      ? organisation.center.split(",").map(Number)
      : organisation.center;
  }, [organisation.center]);

  const fitToHistory = useCallback(() => {
    if (!filteredDevices.length) return;

    const bounds = new mapboxgl.LngLatBounds();
    filteredDevices.forEach((device) => {
      bounds.extend([Number(device.lng), Number(device.lat)]);
    });

    if (bounds.getNorthEast().distanceTo(bounds.getSouthWest()) < 500) {
      bounds.extend([
        bounds.getNorthEast().lng + 0.001,
        bounds.getNorthEast().lat + 0.001,
      ]);
      bounds.extend([
        bounds.getSouthWest().lng - 0.001,
        bounds.getSouthWest().lat - 0.001,
      ]);
    }

    //fit to bounds
    mapRef.current?.fitBounds(bounds, {
      padding: 100,
      duration: 1000,
      pitch: pitch,
      animate: false,
    });
  }, [filteredDevices, mapRef, pitch]);

  const initialViewState = useMemo(() => {
    if (!organisation.centerandzoom || organisation.centerandzoom === "false") {
      return {};
    }

    return {
      latitude: center[1] || 0,
      longitude: center[0] || 0,
      zoom: organisation.zoom !== "false" ? organisation.zoom : 10,
    };
  }, [organisation, center]);

  return {
    filteredDevices,
    center,
    fitToHistory,
    initialViewState,
  };
};
